<template>
    <div class="relatorios">
        <el-form label-position="top">
            <c-panel title="FILTROS">
                <el-row :gutter="10" class="u-mt-10">
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                            <el-select v-model="filtro.instituicao_id" @change="getTurmas" filterable placeholder="Pesquisar Instituição" clearable style="width: 100%;">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="style-form" v-else>
                            <label class="el-form-item__label">Instituição</label>
                            <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Data" key="data">
                            <el-date-picker v-model="filtro.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione o dia" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma (opcional)" key="turma">
                            <el-select v-model="filtro.turma_id" clearable filterable placeholder="Todas as turmas" style="width: 100%;">
                                <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                    <el-option v-for="t in grupo" :key="t.id" :label="`${t.curso.nome} ${t.nome}`" :value="t.id"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>
        </el-form>

        <div class="u-mt-10">
            <el-row>
                <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                    <el-button @click="gerar" type="primary"><i class="el-icon-printer"></i> GERAR PDF</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CPanel from '../../../shared/c-panel/c-panel.vue'

export default {
    components: { CPanel },
    data: () => ({
        turmas: [],
        filtro: {
            instituicao_id: '',
            periodo_id: '',
            turma_id: '',
            data: ''
        }
    }),
    computed: {
        ehSmed () {
            const t = this.$store.state.user.tipo
            return t == 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        this.filtro.periodo_id = this.$store.state.config.periodo.id
        this.filtro.data = this.$moment().format('YYYY-MM-DD')

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.getTurmas()
    },
    methods: {
        getTurmas () {
            this.filtro.turma_id = ''
            this.turmas = []
            if (!this.filtro.instituicao_id || !this.filtro.periodo_id) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_id}`, this.$store.getters.getHeaderAuth)
                .then(response => { this.turmas = response.data })
                .catch(error => { this.$store.commit('throwException', error) })
        },
        gerar () {
            if (!this.filtro.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'É necessário selecionar uma instituição.', type: 'warning' })
                return
            }
            if (!this.filtro.data) {
                window.eventBus.$emit('alert', { msg: 'Selecione a data.', type: 'warning' })
                return
            }

            window.eventBus.$emit('print', {
                url: '/api/pdf/renderAlunosPresentes',
                param: {
                    instituicao_id: this.filtro.instituicao_id,
                    periodo_id: this.filtro.periodo_id || '',
                    turma_id: this.filtro.turma_id || '',
                    data: this.filtro.data
                }
            })
        }
    }
}
</script>
